import { html } from '/vendor/htm-preact.module.js';

/**
 * The shape of a row, while its content is on its way.
 *
 * Not decoration. A screen that empties to "Loading…" and refills throws away
 * the layout and then rebuilds it, so everything below jumps twice; and a
 * screen that draws its empty state first tells you something untrue. A block
 * the size of the answer does neither.
 */
export function RowSkeleton({ height = '3rem' }) {
  return html`<div class="skel" data-testid="skeleton"
                   style=${`height:${height}`}></div>`;
}
